import React, { useEffect, useState } from 'react';
import { AppHeader } from '../../components/AppHeader/AppHeader';
import { useShellNav } from '../../access/useShellNav';
import {
  Icon,
  MenuLeaf,
  Sidebar,
  Submenu,
} from 'barte-design-system';
import { DeviceMobileSpeaker, Percent, Vault } from '@phosphor-icons/react';
import './BackofficeLayout.css';

export type BackofficeActiveItem =
  | 'terminais'
  | 'taxas-company-upload-csv'
  | 'taxas-company-copia-cola'
  | 'sheets-preview'
  | 'bolsao';

interface BackofficeLayoutProps {
  activeItem?: BackofficeActiveItem;
  children: React.ReactNode;
}

export function BackofficeLayout({ activeItem, children }: BackofficeLayoutProps) {
  const { sidebarProps, navigate } = useShellNav();

  // Estado controlado do menu Taxas Company. Inicia aberto se a página atual
  // for uma das versões. Clicar no item-pai alterna abrir/fechar manualmente.
  const isOnTaxasCompany =
    activeItem === 'taxas-company-upload-csv' ||
    activeItem === 'taxas-company-copia-cola' ||
    activeItem === 'sheets-preview';
  const [taxasCompanyOpen, setTaxasCompanyOpen] = useState<boolean>(isOnTaxasCompany);

  // Se o usuário navegar pra uma página de Taxas Company, garante que o menu abre.
  useEffect(() => {
    if (isOnTaxasCompany) setTaxasCompanyOpen(true);
  }, [isOnTaxasCompany]);

  return (
    <div className="app-layout">
      <AppHeader variant="backoffice" avatarProps={{ variant: 'icon', color: 'inverse' }} />

      <div className="app-body">
        <Sidebar {...sidebarProps}>
          <MenuLeaf
            label="Terminais"
            icon={<Icon icon={DeviceMobileSpeaker} size={20} weight="regular" />}
            isActive={activeItem === 'terminais'}
            onClick={() => navigate('/backoffice/pos')}
          />
          <MenuLeaf
            label="Bolsão"
            icon={<Icon icon={Vault} size={20} weight="regular" />}
            isActive={activeItem === 'bolsao'}
            onClick={() => navigate('/backoffice/bolsao')}
          />
          <MenuLeaf
            label="Taxas Company"
            icon={<Icon icon={Percent} size={20} weight="regular" />}
            isOpen={taxasCompanyOpen}
            onClick={() => setTaxasCompanyOpen((o) => !o)}
          >
            <Submenu
              label="Upload CSV"
              isActive={activeItem === 'taxas-company-upload-csv'}
              onClick={() => navigate('/backoffice/taxas-company/upload-csv')}
            />
            <Submenu
              label="Copia e Cola"
              isActive={activeItem === 'taxas-company-copia-cola'}
              onClick={() => navigate('/backoffice/taxas-company/copia-cola')}
            />
            <Submenu
              label="Sheets Preview"
              isActive={activeItem === 'sheets-preview'}
              onClick={() => navigate('/backoffice/sheets/preview')}
            />
          </MenuLeaf>
        </Sidebar>

        {children}
      </div>
    </div>
  );
}
